'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ConfirmDepositModal = ConfirmDepositModal;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _buttons = require('@sitebase/ui-kit/es/buttons');

var _constants = require('../../constants');

var _icons = require('../../icons');

var _currencySignFormatter = require('../../utils/currencySignFormatter');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ConfirmDepositModal(_ref) {
  var confirm = _ref.confirm,
      cancel = _ref.cancel,
      currencyCode = _ref.currencyCode,
      maxDeposit = _ref.maxDeposit,
      _ref$t = _ref.t,
      t = _ref$t === undefined ? function () {
    var ctx = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    return function (msg) {
      return '' + ctx + msg;
    };
  } : _ref$t;

  var translate = t(_constants.TRANSLATION_CONTEXT);

  return _react2.default.createElement(
    'div',
    { className: 'qd-confirm-deposit-modal-wrapper' },
    _react2.default.createElement(
      'div',
      { className: 'qd-confirm-deposit-modal' },
      _react2.default.createElement(
        'div',
        { className: 'qd-confirm-deposit-modal__header' },
        _react2.default.createElement(
          'div',
          { className: 'qd-confirm-deposit-modal__title' },
          translate('CONFIRM_DEPOSIT_MODAL_TITLE')
        ),
        _react2.default.createElement(
          'div',
          { className: 'qd-confirm-deposit-modal__close', onClick: cancel },
          _react2.default.createElement(_icons.X, null)
        )
      ),
      _react2.default.createElement(
        'div',
        { className: 'qd-confirm-deposit-modal__content' },
        _react2.default.createElement(
          'div',
          { className: 'qd-confirm-deposit-modal__deposit-amount' },
          translate('CONFIRM_DEPOSIT_MODAL_YOUR_DEPOSIT'),
          ' ',
          (0, _currencySignFormatter.currencySignFormatter)(maxDeposit, currencyCode)
        ),
        _react2.default.createElement(
          'div',
          { className: 'qd-confirm-deposit-modal__description' },
          translate('CONFIRM_DEPOSIT_MODAL_DESCRIPTION')
        ),
        _react2.default.createElement(
          'div',
          { className: 'qd-confirm-deposit-modal__limits-info' },
          _react2.default.createElement(
            'div',
            { className: 'qd-confirm-deposit-modal__max-limit' },
            _react2.default.createElement(
              'div',
              null,
              translate('CONFIRM_DEPOSIT_MODAL_YOUR_LIMIT')
            ),
            _react2.default.createElement(
              'div',
              null,
              (0, _currencySignFormatter.currencySignFormatter)(maxDeposit, currencyCode)
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'qd-confirm-deposit-modal__remaining-limit' },
            _react2.default.createElement(
              'div',
              null,
              translate('CONFIRM_DEPOSIT_MODAL_REMAINING_LIMIT')
            ),
            _react2.default.createElement(
              'div',
              null,
              (0, _currencySignFormatter.currencySignFormatter)('0.00', currencyCode)
            )
          )
        ),
        _react2.default.createElement(
          _buttons.Button,
          {
            outfit: 'quaternary large expanded',
            className: 'qd-confirm-deposit-modal__confirm-button',
            onClick: confirm
          },
          translate('CONFIRM_DEPOSIT_MODAL_BTN_CONFIRM')
        ),
        _react2.default.createElement(
          _buttons.Button,
          { outfit: 'senary large expanded', className: 'qd-confirm-deposit-modal__cancel-button', onClick: cancel },
          translate('CONFIRM_DEPOSIT_MODAL_BTN_CANCEL')
        )
      )
    )
  );
}